// extracted by mini-css-extract-plugin
export default {"bar":"SearchBar_bar__jtrJs","input":"SearchBar_input__bIy50","button":"SearchBar_button__T7RTc","lupa":"SearchBar_lupa__F2gsg"};